import produce from 'immer';
import { ReducerAction } from 'store/modules/types';

// TYPES
import { Types, ExcluirParametroSistema } from './types';

export const INITIAL_STATE: ExcluirParametroSistema = {
	status: 0,
	data: null,
};

export default function excluirParametroSistemaReducer(
	state = INITIAL_STATE,
	action: ReducerAction,
): ExcluirParametroSistema {
	return produce(state, draft => {
		switch (action.type) {
			case Types.EXCLUIR_PARAMETRO_SISTEMA: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			case Types.EXCLUIR_PARAMETRO_SISTEMA_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.EXCLUIR_PARAMETRO_SISTEMA_FAILURE: {
				draft.status = 400;
				break;
			}

			case Types.EXCLUIR_PARAMETRO_SISTEMA_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
	});
}
